/**
 * Internal staff accounts hidden from client user tables. Mirrors the
 * EXCLUDED_ANALYTICS_EMAILS default in backend-tenant
 * (src/config/excludedEmails.js), which already keeps them out of every stat.
 */
export const HIDDEN_USER_EMAILS: ReadonlyArray<string> = ['clientsuccess@apexialabs.ai'];

export function isHiddenUserEmail(email: string | null | undefined): boolean {
  return !!email && HIDDEN_USER_EMAILS.includes(email.trim().toLowerCase());
}
